import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $connectionStore } from '@lib/store';
import { RoutePaths } from '@shared/utils';
import { IntegrationType } from '@shared/api';

export const IntegrationsCallbackPage = () => {
  const location = useLocation();

  const connectionStore = useUnit($connectionStore.store);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    if (query.has('code')) {
      const code = query.get('code');
      if (code) $connectionStore.events.confirmConnect({ service: IntegrationType.XERO, code });
    }
  }, [location.search]);

  useEffect(() => {
    if (connectionStore.data === 'confirmed') window.location.href = RoutePaths.integrations.onNavigate();
  }, [connectionStore.data]);

  return null;
};
